/* eslint-disable key-spacing, sort-keys */
// constants for every cell the UserInstitutions table can render
export const USER_INSTITUTION_CELL = {
  INSTITUTION:     'institution',
  PARENT_DISTRICT: 'parentDistrict',
  CITY:            'city',
  STATE:           'state',
  COUNTRY:         'country',
  REMOVE:          'remove'
};

export const ALL_USER_INSTITUTION_CELLS = [
  USER_INSTITUTION_CELL.INSTITUTION,
  USER_INSTITUTION_CELL.PARENT_DISTRICT,
  USER_INSTITUTION_CELL.CITY,
  USER_INSTITUTION_CELL.STATE,
  USER_INSTITUTION_CELL.COUNTRY,
  USER_INSTITUTION_CELL.REMOVE
];

export const DEFAULT_USER_INSTITUTION_CELLS = [
  USER_INSTITUTION_CELL.INSTITUTION,
  USER_INSTITUTION_CELL.REMOVE
];
